<template>
  <Row class="page3" style="padding-left: 4vw; padding-right: 4vw;overflow-y: auto;">
    <div style="display: flex" class="swiper-container">
      <div class="swiper-wrapper">
      <div
        v-for="(itemList,index) in list"
        class="swiper-slide"
        style="
          height: 100%;
          background: rgba(87, 87, 87, 0.3);
          display: flex;
          margin-right: 2vw;
        "
      >
        <div
          class="center-bottom overHeight"
          style="height: 100%; display: flex; align-items: center"
        >
          <div
            class="buPart four"
            style="width: 100%; display: flex; height: 100%"
          >
            <div style="width: 20vw">
              <div class="changeRateTitle">
                <span class="dot"></span>
                <span class="word" style="font-size: 0.9vw; color: #bf9d63"
                  >{{ index }}</span
                >
              </div>
              <div class="yellowList overHeight">
                <div class="yellowItem" 
                @click="toIframe(item.company, item['风险名称'])"
                v-for="item in itemList">
                <div style="display: flex;">
                  <div :class="getDayDot(item['总风险值'])" style="flex-shrink: 0;margin-top:0.4vw;"></div>
                  <div class="name">
                    {{ item['风险名称'] }}
                  </div>
                </div>
                 
                  <div style="display:flex;align-items: center;justify-content: space-between;color:#FFF;margin-top:0.5vw;">
                          <div>{{ item.key1 }}</div>
                          <div>{{ item.value1 }}</div>
                        </div>
                        <div style="display:flex;align-items: center;justify-content: space-between;color:#FFF;margin-top:0.5vw;">
                          <div>{{ item.key2 }}</div>
                          <div>{{ item.value2 }}</div>
                        </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 如果需要导航按钮 -->
    <div class="swiper-button-prev"></div>
        <div class="swiper-button-next"></div>
    </div>
  </Row>
</template>

<script>
import {
  queryDepartmentRiskIndicators
} from "../api/index";
import Swiper from "swiper";
import "swiper/dist/css/swiper.min.css";
import "swiper/dist/js/swiper.min";
import { useDataStore } from "@/store";
import { mapActions } from "pinia";

export default {
  name: "page3",
  components: {
    // ring,
  },
  created() {
    // sysLogin()
    this.getData();
    let userInfo = localStorage.getItem("bbsUserInfo");
    if (userInfo) {
      this.setTitle(JSON.parse(userInfo).companyName);
    }
    this.setBackurl("/");
    this.setLeftTop(false);
  },
  data() {
    return {
      list: []
    };
  },
  methods: {
    ...mapActions(useDataStore, ["setTitle", "setLeftTop", "setBackurl"]),
    getDayDot(riskValue) {
          if (riskValue == 0) {
            // 绿灯
            return "dot3";
          } else if (riskValue > 0 && riskValue < 99) {
            //黄灯
            return "dot2";
          } else if (riskValue >= 99) {
            //红灯
            return "dot1";
          }
    },
    toIframe(key1, key2) {
      this.$router.push({
        path: `/PC/page/${key1}/${key2}`,
      });
    },
    async getData() {
      const res = await queryDepartmentRiskIndicators();
      if (res.code == 200) {
        this.list = res.data
        this.$nextTick(() => {
          new Swiper(".swiper-container", {
            slidesPerView: 4,  // 每次显示的项目数量
            spaceBetween: 30,   // 项目之间的间距
            // slidesPerView: "auto",
            // 如果需要分页器
            pagination: ".swiper-pagination",
            // 如果需要前进后退按钮
            nextButton: ".swiper-button-next",
            prevButton: ".swiper-button-prev",
          });
        });
      }
    },
    jump(page) {
      if (page) {
        this.$router.push(page);
      }
    },
  },
  mounted() {
   
  },
  beforeDestroy() {
  },
};
</script>

<style lang="less" scoped>
@import "~@/assets/less/index.less";
.swiper-button-prev {
  background-image: url("../assets/images/lr.png");
  width: 13px;
  height: 23px;
  background-size: 100% 100%;
  margin-top: -0.8vw;
}
.swiper-button-next {
  background-image: url("../assets/images/rr.png");
  width: 13px;
  height: 23px;
  background-size: 100% 100%;
  margin-top: -0.8vw;
}
.yellowTitle {
  color: #bf9d63;
  font-family: Microsoft YaHei;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}
.yellowWrap {
  display: flex;
  flex-direction: column;
}
.yellowList {
  flex: 1;
  .yellowItem {
    cursor: pointer;
    margin-top: 20px;
    margin-left: auto;
    margin-right: auto;
    width: 85%;
    //min-height: 3.5vw;
    flex-shrink: 0;
    background: rgba(87, 87, 87, 0.4);
    padding: 14px;
    text-align: center;
    .dot1 {
  width: 7.5px;
  height: 7.5px;
  border-radius: 50%;
  margin-right: 5px;
  background: #e16a6a;
}
.dot2 {
  width: 7.5px;
  height: 7.5px;
  border-radius: 50%;
  margin-right: 5px;
  background: #e4cc88;
}
.dot3 {
  width: 7.5px;
  height: 7.5px;
  flex-shrink: 0;
  border-radius: 50%;
  margin-right: 5px;
  background: #59cf7a;
}
    .greendot {
      width: 8px;
      height: 8px;
      flex-shrink: 0;
      border-radius: 50%;
      background-color: #59cf7a;
    }
    .yellowline2 {
      width: 100%;
      text-align: center;
      display: flex;
      align-items: center;
      justify-content: center;
      .number {
        color: #fff;
        font-family: Microsoft YaHei;
        font-size: 1.8vw;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
        letter-spacing: -2.88px;
        padding-right: 6px;
      }
      .day {
        color: #fff;
        font-family: Microsoft YaHei;
        font-size: 0.8vw;
        font-style: normal;
        font-weight: 400;
        line-height: normal;
        padding-top: 0.7vw;
      }
    }
    .name {
      color: #fff;
      font-family: Microsoft YaHei;
      font-size: 14px;
      font-style: normal;
      font-weight: 400;
      line-height: normal;
    }
  }
}
.red {
}
.green {
  color: #6bbb57;
}
.top-wrapper-item_middle {
  font-weight: 400;
  color: #fff;
  .top-wrapper-item_middle_text {
    &::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      margin-right: 12px;
      border: 3px solid rgba(225, 106, 106, 1);
      border-radius: 100%;
    }

    &.color2::before {
      border-color: rgba(228, 204, 136, 1);
    }
    &.color3::before {
      border-color: rgba(89, 207, 122, 1);
    }
  }
}
.orange3 {
  display: flex;
  color: #fff;
  align-items: center;
  border-radius: 2px;
  background: rgb(147, 127, 86);
  padding-top: 0.5vh;
  padding-bottom: 0.5vh;
  .line {
    width: 1px;
    height: 30px;
    flex-shrink: 0;
    opacity: 0.14000000059604645;
    background: #fff;
  }
  .item {
    font-size: 0.8vw;
    width: 33%;
    text-align: center;
  }
}
.changeRate {
  padding-left: 3%;
  padding-right: 4%;
  width: 100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
    linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
    linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
  background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
  padding: 10px 20px;
  .changeRateTitle {
    color: #bf9d63;
    // margin-bottom: 10px;
  }
}
.redTrangle {
  /* 1.首先设置盒子宽高都为0 */
  width: 0;
  height: 0;
  /*2.设置盒子上下左右边框(注意:根据三角形大小调整边框粗细,颜色要设置为透明transparent) */
  border: 4px solid transparent;
  /*3.根据三角形方向选择设置哪个方向边框为none
                技巧:设置三角形正对方向的边框为none,比如我想设置朝上的三角形，那就设置上边框为none*/
  border-top: none;
  /*4.最后设置边框颜色，显示出三角形*/
  border-bottom-color: #f06161;
  margin-right: 3px;
}
.greenTrangle {
  width: 0px;
  height: 0px;
  border: 4px solid transparent;
  border-top-color: #6bbb57;
  margin-right: 3px;
}
.buPartWrap {
  cursor: pointer;
  display: inline-block;
  width: 100%;
  height: 4.5vw;
  // height: 180px;
  //   background: rgba(87, 87, 87, 0.3);
  //   border: 1px solid #4d4a48;
  margin-top: 1vw;
  &:first-child {
    margin-top: 1.2vw;
  }
  &:nth-child(n + 1) {
    // margin-top: 2vw;
  }
  .buPart {
    width: 100%;
    height: 100%;
    background: linear-gradient(to left, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) right top no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to bottom, #bf9d63, #bf9d63) left bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat,
      linear-gradient(to left, #bf9d63, #bf9d63) right bottom no-repeat;
    background-size: 1px 20px, 20px 1px, 1px 20px, 20px 1px;
    padding-left: 1vw;
    padding-right: 1vw;
    padding-top: 0.5vw;
    padding-bottom: 0.5vw;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    // padding: 1.5vw 20px 0;
    .buPartTitle {
      color: #bf9d63;
      // font-weight: 600;
      // margin-bottom: 28px;
      //   font-size: 20px;
      font-size: 1.2vw;
      line-height: 27px;
    }
    .line {
      display: flex;
      align-items: center;
      justify-content: space-between;
      line-height: 34px;
      .span1 {
        color: #ffffff;
        opacity: 0.6;
        font-size: 1.2vw;
        // font-size: 1vw;
      }
      .span2 {
        font-size: 1.4vw;
        color: #ffffff;
        opacity: 0.8;
        // font-size: 1.5vw;
      }
    }
  }
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  box-sizing: border-box;
}
.center-bottom {
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  .background-4-img;
  padding: 20px;
  .center-bottom-title {
    font-size: 16px;
    line-height: 24px;
    color: rgba(191, 157, 99, 1);
    font-weight: 300;
  }
}
.dot {
  margin-right: 10px;
  display: inline-block;
  border-radius: 50%;
  width: 10px;
  height: 10px;
  background: linear-gradient(180deg, #bf9d63 0%, rgba(217, 217, 217, 0) 100%);
}

.tableList {
  .item {
    display: flex;
    align-items: center;
    &:nth-child(odd) {
      background: rgba(87, 87, 87, 0.5);
    }
    height: 38px;
    line-height: 38px;
    justify-content: space-between;
    .left {
      font-size: 1vw;
      color: #ffffff;
      opacity: 0.6;
      padding-left: 10px;
    }
    .center {
      font-weight: 400;
      font-size: 1vw;
      color: #ffffff;
      text-align: center;
    }
    .right {
      text-align: right;
      padding-right: 10px;
      font-weight: 400;
      font-size: 1vw;
      color: #f06161;
      .dotRed {
        position: relative;
        bottom: 0.1vw;
        display: inline-block;
        margin-right: 5px;
        width: 0.5vw;
        height: 0.5vw;
        // border-radius: 50%;
        // background: #f06161;
        /* 1.首先设置盒子宽高都为0 */
        width: 0.5vw;
        height: 0.5vw;
        /*2.设置盒子上下左右边框(注意:根据三角形大小调整边框粗细,颜色要设置为透明transparent) */
        border: 6px solid transparent;
        /*3.根据三角形方向选择设置哪个方向边框为none
                技巧:设置三角形正对方向的边框为none,比如我想设置朝上的三角形，那就设置上边框为none*/
        border-top: none;
        /*4.最后设置边框颜色，显示出三角形*/
        border-bottom-color: #f06161;
      }
      .dotGreen {
        position: relative;
        top: 0.1vw;
        display: inline-block;
        // border-radius: 50%;
        // background: #6bbb57;
        width: 0.5vw;
        height: 0.5vw;
        border: 6px solid transparent;
        border-top-color: #6bbb57;
        margin-right: 5px;
      }
    }
    > div {
      width: 33%;
    }
  }
}
.changeRateWrap {
  flex: 1;
  background: rgba(87, 87, 87, 0.3);
  border: 1px solid #4d4a48;
  //   height: calc(100% - 32px - 40%);
  position: relative;
  //   top: -20px;

  .changeRateTitle {
    display: flex;
    align-items: center;

    .word {
      font-size: 16px;
      color: #bf9d63;
    }
  }
}
.page3 {
  .left1 {
    .changeItem {
      font-size: 0.9vw;
      margin-bottom: 20px;
      position: relative;
      //   top: -60px;

      .item {
        cursor: pointer;
        text-align: center;
        display: inline-block;
        // margin-right: 40px;
        min-width: 105px;
        height: 40px;
        line-height: 40px;
        color: #bf9d63;
        // padding: 8px 14px;
        color: #fff;
        &.active {
          background: #4a3e29;
          border-radius: 60px;
          color: #bf9d63;
        }
      }
    }
  }
  height: 100%;
  width: 100%;
  padding: 14px 20px 20px;
  //   background: #03044a;
  // overflow: hidden;

  .ivu-col {
    height: 100%;
    float: left;
  }

  .left,
  .right1-1,
  .center-bottom {
    // background: rgba(87, 87, 87, 0.3);
    // border: 1px solid #4d4a48;
    height: 100%;
    // border: 1px solid #0d2451;
    position: relative;
    // background: #151456;

    #left_5 {
      height: 100%;
      width: 45%;
      float: left;
    }

    #left_6 {
      height: 100%;
      width: 55%;
      float: left;
    }

    .circular {
      height: 100%;

      .canvas {
        height: 100%;
        width: 30%;
        float: left;

        .subtitle {
          font-size: 12px;
          font-weight: bold;
          color: #fff;
          height: 25px;
          padding: 10px 0;
          text-align: center;
        }

        .canvasList {
          height: calc(~"100% - 25px");
          text-align: center;
        }
      }
    }

    .left1 {
      //   border-bottom: 1px solid #0d2451;
      //   background: #151456;
    }

    .title {
      position: absolute;
      display: inline-block;
      color: #6eddf1;
      border: 2px solid #6eddf1;
      height: 18px;
      padding: 0 2px;
      left: 50%;
      transform: translate(-50%, -50%);

      .title-text {
        position: relative;
        font-size: 16px;
        background: #09102e;
        display: inline-block;
        padding: 0 4px;
        transform: translateY(-5px);
      }
    }
  }

  .center-top {
    height: 70%;
  }

  .center-bottom {
    height: 30%;

    .bottom-radars {
      height: 100%;
    }

    .bottom-bars {
      height: 45%;
    }
  }

  .right-1 {
    height: 30%;

    .right1-1 {
      height: 92%;
    }
  }

  .right-2 {
    height: 40%;
  }
}
</style>
